import React, { useEffect, useState } from 'react';
import { withAuctionCore } from 'agent';
import { observer } from 'mobx-react-lite';
import useStores from 'hooks/useStore';
import PropTypes from 'prop-types';
import Select from 'react-select';

import filterBrands from 'components/utils/filterBrands';

const colourStyles = (error) => ({
  control: (styles) => ({
    ...styles,
    backgroundColor: 'white',
    marginBottom: 15,
    borderColor: error && 'red',
    borderWidth: error && 5,
  }),
  option: (styles, {
    isFocused,
  }) => ({
    ...styles,
    color: 'black',
    textAlign: 'left',
    backgroundColor: isFocused ? '#ccc' : null,

  }),
});

const YMMLookup = observer(({
  auctioncore,
}) => {
  const { UIStore } = useStores();
  const {
    year,
    make,
    model,
    setLoading,
    setProperty,
    makesList,
    modelsList,
    yearList,
    salesForce,
  } = UIStore;

  useEffect(() => {
    setLoading(true);
    auctioncore.getVehicleYears()
      .then((response) => setProperty('yearList', response.data.lookupItems))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (year) {
      setLoading(true);

      /** Fetch popular models and brands from Auction Core API */
      Promise.all([auctioncore.getPopularModels(), auctioncore.getVehicleBrands()])
        .then((response) => {
          const res = filterBrands(response);
          setProperty('makesList', res);
        })
        .finally(() => setLoading(false));
    }
  }, [year]);

  useEffect(() => {
    if (year && make) {
      setLoading(true);
      auctioncore.getVehicleModels(year, make)
        .then((response) => setProperty('modelsList', response.data.lookupItems))
        .finally(() => setLoading(false));
    }

    if (!year && !make && !model) {
      setProperty('makesList', null);
      setProperty('modelsList', null);
    }
  }, [make]);

  const getSelected = (arr, value, field) => {
    const list = arr.filter((item) => item.value.toLowerCase() === value.toLowerCase());

    // 4817b3ab-43f8-401a-972b-0634066fb84e
    //
    // 4817b3ab-43f8-401a-972b-0634066fb84e

    if (!list[0]) {
      return null;
    }

    if (field === 'make') {
      setProperty('makeName', list[0].text);
    }

    if (field === 'model') {
      setProperty('modelName', list[0].text);
    }

    return {
      label: list[0].text,
      value: list[0].value,
    };
  };

  return (
    <div>
      {yearList && (
        <Select
          styles={colourStyles()}
          isSearchable={false}
          value={year && {
            label: year,
            value: year,
          }}
          placeholder="Select Year..."
          // getStyles={(a, b) => console.log(a, b)}
          onChange={(e) => {
            setProperty('year', e.value);
            setProperty('make', null);
            setProperty('model', null);
          }}
          options={yearList.map((item) => ({
            label: item.text,
            value: item.value,
          }))}
        />
      )}

      {makesList && (
      <Select
        styles={colourStyles()}
        isSearchable
        value={make && getSelected(makesList, make, 'make')}
        placeholder="Search Brand..."
        onChange={(e) => {
          setProperty('make', e.value);
          setProperty('makeName', e.label);
        }}
        options={makesList.map((item) => ({
          label: item.text,
          value: item.value,
        }))}
      />
      )}

      {modelsList && (
      <Select
        styles={colourStyles()}
        value={model && getSelected(modelsList, model, 'model')}
        isSearchable
        placeholder="Search Model..."
        onChange={(e) => {
          setProperty('model', e.value);
          setProperty('modelName', e.label);
        }}
        options={modelsList.map((item) => ({
          label: item.text,
          value: item.value,
        }))}
      />
      )}
    </div>
  );
});

YMMLookup.propTypes = {
  auctioncore: PropTypes.object.isRequired,
};

export default withAuctionCore(YMMLookup);
